module.exports = __webpack_public_path__ + "static/media/m_bilal_selostannu.3dff3f45.jpg";